import { h, Component } from "preact";
import style from "./style";
import { numberToCurrencyFormatter } from "../../utils/numberFormatter";

export default class AllThemesBar extends Component {
  render() {
    const projectDetails = this.props.data;
    return (
      <div className={style.mainWrapper}>
        <div>
          <b>
            {projectDetails && projectDetails.budget
              ? numberToCurrencyFormatter(projectDetails.budget, 2)
              : "-"}
          </b>
          <span>Total Budget</span>
        </div>
        <div>
          <b>
            {projectDetails && projectDetails.expense
              ? numberToCurrencyFormatter(projectDetails.expense, 2)
              : "-"}
          </b>
          <span>Total Expense</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/allThemesBar/index.js